// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React examples
import SimpleInfoCard from "custom/Cards/InfoCards/SimpleInfoCard";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";


function Information() {
  return (
    <MKBox component="section" py={6} mt={6}>
      <Container>
        <Grid container spacing={3} item xs={12} lg={8} mx="auto">
          <MKTypography variant="h3" mb={7}>
            ¿Qué es la Prueba de Penetración Continua?
          </MKTypography>
          <MKTypography variant="body2" align="justify">
            La Prueba de Penetración Continua, a menudo denominada prueba de penetración continua o recurrente, es un enfoque sistemático y constante para evaluar la postura de seguridad de una organización. A diferencia de las pruebas de penetración tradicionales, que se realizan de forma periódica, la prueba de penetración continua implica pruebas programadas regularmente utilizando herramientas automatizadas, como Nessus, junto con pruebas manuales para identificar vulnerabilidades y debilidades.
          </MKTypography>
          <MKTypography variant="h3" mb={7} mt={7}>
            Aspectos Clave de la Prueba de Penetración Continua
          </MKTypography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="motion_photos_auto"
                title="Automatización y Pruebas Manuales"
                description="La prueba de penetración continua combina el uso de herramientas automatizadas, como Nessus, con pruebas manuales realizadas por profesionales de seguridad capacitados. Este enfoque dual garantiza una cobertura exhaustiva."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="format_list_bulleted"
                title="Evaluación Regular"
                description="La prueba de penetración continua se realiza a intervalos regulares, como semanal, mensual o trimestralmente, dependiendo de las necesidades y el perfil de riesgo de la organización."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="low_priority"
                title="Priorización de Riesgos"
                description="Los resultados de las pruebas de penetración continua se analizan y priorizan según el riesgo, lo que permite a las organizaciones abordar primero las vulnerabilidades más críticas."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="nearby_error"
                title="Informes y Remediación"
                description="Las organizaciones reciben informes detallados después de cada ciclo de pruebas, destacando vulnerabilidades, posibles impactos y recomendaciones de mitigación. Estos informes guían los esfuerzos de remediación."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="published_with_changes"
                title="Evaluación Dinámica de Vulnerabilidades"
                description="Implica la identificación y prueba de nuevas vulnerabilidades a medida que surgen, asegurando que las defensas de una organización se mantengan actuales y adaptativas."
              />
            </Grid>
          </Grid>
          <MKTypography variant="h3" mb={7} mt={7}>
            ¿Por qué Importa la Prueba de Penetración Continua?
          </MKTypography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="bolt"
                title="Defensa Proactiva"
                description="La prueba de penetración continua permite la identificación y remediación proactiva de vulnerabilidades antes de que actores malintencionados puedan explotarlas."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="360"
                title="Adaptabilidad"
                description="Garantiza que la postura de seguridad de una organización sea adaptativa y esté actualizada, abordando amenazas y vulnerabilidades emergentes."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="timer"
                title="Reducción del Tiempo de Exposición"
                description="Las pruebas regulares reducen el tiempo durante el cual las vulnerabilidades están expuestas, minimizando la ventana de oportunidad para los atacantes."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="gavel"
                title="Cumplimiento y Garantía"
                description="La prueba de penetración continua respalda el cumplimiento de estándares de la industria y requisitos regulatorios para evaluaciones de seguridad continuas."
              />
            </Grid>
          </Grid>
          <MKTypography variant="h3" mb={7} mt={7}>
            El Rol de la Prueba de Penetración Continua en la Ciberseguridad
          </MKTypography>
          <MKTypography variant="body2" align="justify">
            La Prueba de Penetración Continua es un elemento fundamental de una estrategia integral de ciberseguridad. Ayuda a las organizaciones a mantener una defensa inquebrantable contra un panorama de amenazas en constante evolución. Al adoptar la prueba de penetración continua con herramientas como Nessus, las organizaciones pueden identificar, evaluar y remediar vulnerabilidades de manera proactiva, asegurando que su postura de seguridad permanezca resiliente y adaptativa en un mundo digital cada vez más conectado.
          </MKTypography>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
